module.exports = __webpack_public_path__ + "static/Riccardo_Bellocchio-be60041b9c12fc7890330848606f57b5.jpg";